import { useMutation, useQueryClient } from "@tanstack/react-query";
import { t } from "i18next";

import { errorHandler } from "#app/monitoring/errorHandler";
import { showErrorToast, showSuccessToast } from "#app/notifications";
import { createPredictionFeedback } from "#modules/feedback/infra/createPredictionFeedback.api";

export const useCreatePredictionFeedback = (params?: {
  options?: {
    onSuccess?: () => void;
    onError?: (err: Error) => void;
    onMutate?: () => void;
  };
}) => {
  const queryClient = useQueryClient();

  const { mutate, ...rest } = useMutation({
    mutationFn: createPredictionFeedback,
    onMutate: () => {
      params?.options?.onMutate?.();
    },
    onSuccess: () => {
      void queryClient.invalidateQueries();
      params?.options?.onSuccess?.();
      showSuccessToast({
        title: t("feedback.success"),
        message: t("feedback.thankYou"),
      });
    },
    onError: (err: Error) => {
      showErrorToast({ title: err.message });
      errorHandler(err);

      params?.options?.onError?.(err);
      showErrorToast({
        title: t("feedback.error"),
        message: t("feedback.errorMessage"),
      });
    },
  });

  return { createPredictionFeedback: mutate, ...rest };
};
